<template>
  <div class="wrap layout" v-if="config && config.nodes">
    <div class="item" :style="`width:${100 / config.columns}%`" v-for="(item, index) in config.nodes" :key="index" @click="actionHandler(item.action)">
      <img class="item__icon" mode="heightFix" :src="item.src" />
    </div>
  </div>
</template>

<script>
import actionMixins from "@/utils/action.mixins";

export default {
  name: "MultiImage",
  mixins: [actionMixins],
  props: {
    config: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .wrap {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .item{
      cursor: pointer;
      .item__icon{
        width: 100%;
      }
    }
  }
  @media screen and (min-width: 48em) {}
  @media screen and (min-width: 64em) {}
</style>